import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw.length < 8) { setErr("Password must be at least 8 characters."); return; }
    if (pw !== pw2) { setErr("Passwords don't match."); return; }
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); setDone(true); }
    catch (e) { setErr(e.response?.data?.detail || "This reset link is invalid or has expired."); }
    finally { setBusy(false); }
  };

  return (
    <div className="payment-result" data-testid="reset-password-page">
      <div className="pay-card">
        {!token ? (
          <><h1>Invalid link</h1><p>This reset link is missing its token. Please request a new one.</p><Link to="/forgot-password" className="primary-btn">Request new link</Link></>
        ) : done ? (
          <><span className="pay-ic ok"><CheckCircle2 size={34} /></span><h1>Password updated</h1><p>You can now sign in with your new password.</p><button className="primary-btn" onClick={() => nav("/login")} data-testid="reset-go-login">Go to sign in</button></>
        ) : (
          <form onSubmit={submit} data-testid="reset-form">
            <h1>Choose a new password</h1>
            <p>Enter and confirm your new password below.</p>
            <input className="auth-input" type="password" placeholder="New password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
            <input className="auth-input" type="password" placeholder="Confirm new password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="reset-password-confirm" />
            {err && <div className="form-error" data-testid="reset-error">{err}</div>}
            <button className="primary-btn full" disabled={busy} data-testid="reset-submit">{busy ? "Updating…" : "Update password"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
